<mat-dialog-content [ngClass]="{ 'modal-content': !showAlternateIntroPop, 'intro-popup': showAlternateIntroPop }" class="" id="welcome-carousel"
(keydown.escape)="smioneLoginRestrictmodalTrue ? logout() : (showAlternateIntroPop ? DarkcloseModal() : closeModal())" aria-modal="true" role="dialog" aria-label="Migration Carousels">
  <!-- <button class="close-button" (click)="closeModal()"> -->
    <!-- // need change -->
 <button type="button" class="close-button" (click)="smioneLoginRestrictmodalTrue ? logout() : (showAlternateIntroPop ? DarkcloseModal() : closeModal())" aria-label="Close">
    <img [src]="closeIcon" alt="" />
  </button>
  
  <ng-container *ngIf="!showAlternateIntroPop && !smioneLoginRestrictmodalTrue; else alternatePopup">
    <!-- Default Carousel -->
    <div class="modal-parent-container">
      <div class="carousel">
        <div class="carousel-text-container">
          <h5 class="slider-heading" [innerHTML]="slides[currentSlideIndex]?.title"></h5>
          <p class="slider-sub-heading" [innerHTML]="slides[currentSlideIndex]?.description"></p>
             <p *ngIf="slides[currentSlideIndex]?.bottomText" class="slider-sub-heading-bottom" [innerHTML]="slides[currentSlideIndex]?.bottomText"></p>
        </div>
     
  <div class="dots-container" role="tablist" aria-label="Carousel slides">
          <button type="button" *ngFor="let slide of slides; let i = index" class="dot" [class.active]="i === currentSlideIndex"
            (click)="goToSlide(i)" (keydown.enter)="goToSlide(i)" (keydown.space)="goToSlide(i); $event.preventDefault()"
            [attr.aria-label]="'Slide ' + (i + 1) + ' of ' + slides.length"
            [attr.aria-current]="i === currentSlideIndex ? 'true' : null"
            role="tab"></button>
        </div>
        <img [src]="slides[currentSlideIndex]?.image" alt="Slide Image" class="carousel-image" loading="lazy" />
      </div>
      <div class="button-container">
        <button class="letsgo-button" (click)="letsgoButton()">{{'TRY_KUDZU' | translate}}</button>
        <button *ngIf="isSkipUpgradeKudzu" class="maybe-later-button" (click)="closeModalMaybeLater()">{{'NOT_NOW' | translate}}</button>
      </div>
    </div>
  </ng-container>

  <ng-template #alternatePopup>
    <ng-container *ngIf="showAlternateIntroPop; else smioneLoginPopup">
      <!-- Alternate Popup -->
      <div class="modal-parent-container">
        <div class="carousel">
          <h5 class="slider-heading">
            <span class="unhighlighted-text">
              <span style="color: #FFFFFF;" class="unhighlighted-text">{{ 'Grow_your' | translate }}</span>
              <span class="highlight-text">{{ 'KUDZU' | translate }}</span>
              <span style="color: #FFFFFF;" class="unhighlighted-text">{{ 'mobile_app' | translate }}</span>
            </span>

          </h5>
          <p class="slider-sub-heading">{{'KUDZU_IS_AN_ONLINE' | translate}}</p>
          <img src="assets/images/Carousal_image.png" alt="Slide Image" class="carousel-image" loading="lazy" />
          <div class="button-container">
            <button class="letsgo-button" (click)="letsDarkModalGoButton()">{{'GET_GROWING' | translate}}</button>
            <button *ngIf="isSkipUpgradeKudzu" class="maybe-later-button" (click)="closeDarkModalMaybeLater()">{{'MAYBE_LATER' | translate}}</button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #smioneLoginPopup>
    <div class="modal-parent-container">
      <div class="carousel smione-login-carousel">
        <p class="kudzu-unhighlighted-text"><span class="kudzu-highlight-text">Uh-oh!</span>{{'DASHBOARD.LETS.GET' | translate}}</p>
        <p class="slider-sub-heading">
          {{'DASHBOARD.YOUR.RECENTLY' | translate}}
        </p>
        <img src="assets/images/Kudzu_mobile.png" alt="restrict-logo" class="carousel-image" loading="lazy" />
        <br>
        <div class="button-container-kudzu">
          <button class="download-button" (click)="redirectToPlayStore()">{{'DOWNLOAD.KUDZU' | translate}}</button>
          <button class="logout-button" (click)="logout()">{{'DASHBOARD.HEADER.LogOut' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>
